import React from 'react';
import { BookOpenIcon, BookTextIcon, TabletIcon, HeadphonesIcon } from 'lucide-react';
// Genre colors fallback for spine color if no cover
export const genreColors: Record<string, string> = {
  'Mystery Thriller': '#4f46e5',
  Horror: '#991b1b',
  'Supernatural Thriller': '#6b21a8',
  'Fantasy Romance': '#059669',
  Adventure: '#ca8a04',
  default: '#111111'
};
// Format icons using Lucide components
export const formatIcons: Record<string, ReactNode> = {
  paperback: <BookOpenIcon className="h-4 w-4" data-id="element-17324" data-mp="1so4qj49avyn" />,
  hardcover: <BookTextIcon className="h-4 w-4" data-id="element-17325" data-mp="1rd1qlimxs8l" />,
  ebook: <TabletIcon className="h-4 w-4" data-id="element-17326" data-mp="6jcw7yfxrsxs" />,
  audiobook: <HeadphonesIcon className="h-4 w-4" data-id="element-17327" data-mp="6knzzy9dt0ow" />
};